var _path, _path2, _path3, _path4, _path5, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26021 3.55859C1.27347 5.54529 0 8.28827 0 11.3133C0 11.6701 0.288669 11.9587 0.645407 11.9587C2.04667 11.9587 3.15961 11.9587 4.56088 11.9587C4.91762 11.9587 5.20629 11.6701 5.20629 11.3133C5.20629 9.71178 5.85767 8.25961 6.90947 7.20786L6.51199 5.51956L5.43102 4.43859L3.26021 3.55859Z",
    fill: "#FF3752"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0145 0.342773C11.0145 0.553951 10.3691 0.759492 10.3691 0.960643C10.3691 2.32895 10.3691 3.49512 10.3691 4.86075C10.3691 5.07064 11.0145 5.28526 11.0145 5.50603C12.6161 5.50603 14.0683 6.15742 15.12 7.20922L15.7072 7.26748L18.4098 4.56486L18.7693 3.55996C16.7826 1.57322 14.0396 0.342773 11.0145 0.342773Z",
    fill: "#70E2FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.26074 3.55996L6.91 7.20922C7.9618 6.15742 9.41397 5.50603 11.0155 5.50603C11.0155 3.63766 11.0155 2.21114 11.0155 0.342773C7.99046 0.342773 5.24748 1.57322 3.26074 3.55996Z",
    fill: "#FDC530"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7704 3.55859L15.1211 7.20786C16.1729 8.25961 16.8243 9.71178 16.8243 11.3133C16.8243 11.6701 17.113 11.9587 17.4697 11.9587C18.871 11.9587 19.9839 11.9587 21.3852 11.9587C21.7419 11.9587 22.0306 11.6701 22.0306 11.3133C22.0306 8.28827 20.7571 5.54529 18.7704 3.55859Z",
    fill: "#0ACF35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6257 6.46912C15.4464 6.30097 15.1661 6.27854 14.953 6.41305C13.1927 7.5455 11.8584 8.39768 10.098 9.51891C9.77292 9.73195 9.50382 10.0123 9.3356 10.3374C8.85347 11.2008 8.99923 12.2883 9.71686 12.9947C10.4568 13.7459 11.6117 13.8693 12.5087 13.3087C12.8563 13.0732 13.1478 12.7481 13.3272 12.3556C14.2129 10.4607 14.8857 9.02557 15.7715 7.13068C15.8724 6.9064 15.8164 6.6373 15.6257 6.46912Z",
    fill: "#1F1F1F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.3398,
    cy: 11.3686,
    rx: 0.571232,
    ry: 0.571233,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditMeter);
export default __webpack_public_path__ + "static/media/CreditMeter.67eb5c10e79090d2450f6f78db57f536.svg";
export { ForwardRef as ReactComponent };